import { PolylineF, PolylineProps } from "@react-google-maps/api";
import { forwardRef } from "react";
import { setRef } from "../helpers";

type Props = PolylineProps & { color?: string };

export const DashedPolyline = forwardRef<google.maps.Polyline, Props>(
  ({ color = "#62514e", options, ...props }, ref) => {
    return (
      <PolylineF
        onLoad={(p) => setRef(ref, p)}
        options={{
          geodesic: false,
          strokeOpacity: 0,
          icons: [
            {
              icon: {
                path: "M 0,-1 0,1",
                strokeOpacity: 1,
                strokeColor: color,
                scale: 2,
              },
              offset: "0",
              repeat: "10px",
            },
            {
              icon: null,
              offset: "0%",
            },
          ],
          ...options,
        }}
        {...props}
      />
    );
  }
);

DashedPolyline.displayName = "DashedPolyline";